<div class="w-100 h-100 d-flex flex-column flex-grow-1">
  <div class="w-100 flex-grow-1">
    <router-outlet></router-outlet>
  </div>
  <div class="w-100 d-flex flex-column">
    <gpay-main-footer></gpay-main-footer>
  </div>
</div>
